<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.cookies.headerTitle')" />

    <div class="base-container-first agreement__wrapper">
      <div class="section">
        <p>{{ t("pages.cookies.firstVisit")}}</p>

        <p>
          {{ t("pages.cookies.weUse") }}
        </p>

        <ul>
          <li>{{ t("pages.cookies.purposes.ensuringCorrectOperation") }}</li>

          <li>{{ t("pages.cookies.purposes.analyzingVisitors") }}</li>

          <li>{{ t("pages.cookies.purposes.improvingService") }}</li>

          <li>{{ t("pages.cookies.purposes.ensuringSecurity") }}</li>

          <li>{{ t("pages.cookies.purposes.personalizingContent") }}</li>
        </ul>

        <p>{{ t("pages.cookies.collectedInformation") }}</p>

        <ul class="list-with-dots">
          <li>{{ t("pages.cookies.informationTypes.ipAddress") }}</li>

          <li>{{ t("pages.cookies.informationTypes.location") }}</li>

          <li>{{ t("pages.cookies.informationTypes.deviceParameters") }}</li>

          <li>{{ t("pages.cookies.informationTypes.browserData") }}</li>

          <li>{{ t("pages.cookies.informationTypes.browsingHistory") }}</li>

          <li>{{ t("pages.cookies.informationTypes.referralSource") }}</li>

          <li>{{ t("pages.cookies.informationTypes.webBeacons") }}</li>

          <li>{{ t("pages.cookies.informationTypes.localStorage") }}</li>

          <li>{{ t("pages.cookies.informationTypes.messengerTracking") }}</li>

          <li>{{ t("pages.cookies.informationTypes.otherTechnologies") }}</li>
        </ul>

        <p>{{ t("pages.cookies.analytics") }}</p>

        <p>{{ t("pages.cookies.agreement") }}</p>

        <p>{{ t("pages.cookies.analyticsGoogle") }}</p>
      </div>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.cookies.orderForm.description')"
    :title="t('pages.cookies.orderForm.title')"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();

useSeoMeta({
  title: t("pages.cookies.seo.title"),
});
</script>

<style scoped>
.agreement__wrapper {
  display: flex;
  flex-direction: column;
  margin: 0 auto 80px;
  padding-bottom: 0;
}

.section-headline {
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
}

@media (--desktop) {
  .agreement__wrapper {
    margin-bottom: 120px;
  }

  .section-headline {
    font-weight: 400;
    font-size: 32px;
    line-height: 1.25;
  }
}

.section {
  display: inline-grid;
  row-gap: 16px;
  margin-bottom: 40px;
}

p,
li {
  font-size: 16px;
  color: var(--grey-1);
  line-height: 1.38;
  letter-spacing: 0.05px;
}

.list-with-dots {
  padding-left: 20px;
  list-style-type: disc;
}
</style>
